import React, { Fragment, useEffect, useState } from "react";
import { Alert } from "blueprints2";
import { injectIntl } from "react-intl";

const AlertTypes = {
  ADD: "add",
  EDIT: "edit",
  ERROR: "error",
  DELETE: "delete",
  MIGRATE: "migrate",
  TOKEN: "token",
};

const CredentialAlert = ({ className, type, extraData, intl }) => {
  const manageAlerts = () => {
    if (type) {
      const createAlerts = document.getElementsByClassName("create_alert");
      const otherAlerts = document.getElementsByClassName("other_alert");

      if (className === "create_alert") {
        if (otherAlerts.length > 0) otherAlerts[0].style.display = "none";
        if (createAlerts.length > 0) createAlerts[0].style.display = "flex";
      }

      if (className === "other_alert") {
        if (otherAlerts.length > 0) otherAlerts[0].style.display = "flex";
        if (createAlerts.length > 0) createAlerts[0].style.display = "none";
      }

      const top = document.getElementById("root");
      window.scroll({
        behavior: "smooth",
        left: 0,
        top: top.offsetTop,
      });
    }
  };

  const [alert, setAlert] = useState({});

  const getAlertProps = () => {
    switch (type) {
      case AlertTypes.ADD:
        return {
          type: "success",
          icon: "checkmark-outline",
          message: intl.formatMessage(
            {
              id: "applications.add.success",
              defaultMessage: "Successfully created API credential: {appName} ",
            },
            { appName: extraData.appName }
          ),
        };
      case AlertTypes.EDIT:
        return {
          type: "success",
          icon: "edit",
          message: intl.formatMessage(
            {
              id: "applications.form.edit.success",
              defaultMessage:
                "Successfully edited API credential for {appName}",
            },
            { appName: extraData.appName }
          ),
        };
      case AlertTypes.DELETE:
        return {
          type: "success",
          icon: "trash",
          message: intl.formatMessage(
            {
              id: "applications.form.delete.submit.sucess",
              defaultMessage: "Successfully deleted API credential {appName}",
            },
            { appName: extraData.appName }
          ),
        };
      case AlertTypes.ERROR:
        return {
          type: "danger",
          icon: "information-outline",
          message: intl.formatMessage({
            id: "applications.form.error",
            defaultMessage: "Error: Internal call to Kong API failed",
          }),
        };
      case AlertTypes.MIGRATE:
        return {
          type: "success",
          icon: "checkmark-outline",
          message: intl.formatMessage({
            id: "applications.form.migrate.sucess",
            defaultMessage:
              "Success! Migrated previous API Credentials to new account",
          }),
        };
      case AlertTypes.TOKEN:
        return {
          type: "success",
          icon: "key",
          message: intl.formatMessage(
            {
              id: "applications.form.token.success",
              defaultMessage:
                "Access Token successfully generated for {app}:  {token}",
            },
            { app: extraData.app, token: extraData.token }
          ),
        };
      default:
        return { isHidden: true };
    }
  };

  useEffect(() => {
    manageAlerts();

    setAlert(getAlertProps(type));
  }, [type, extraData]);
  return (
    !alert.isHidden && (
      <Alert
        isDismissible={false}
        type={alert.type}
        icon={alert.icon}
        className={`mt-4 ${className}`}
      >
        {alert.message || <Fragment />}
      </Alert>
    )
  );
};

export default injectIntl(CredentialAlert);
export { AlertTypes };
